import type { SearchServiceRemindersCriteria, ServiceReminderQueueFilters } from '@hetivo/hetivo-lib-types';

/**
 * Query keys of the Service reminders queue (SWOOP-281). The filters carry the master selection
 * (`locationIds` / `territoryIds`), so a change of territory or location changes every key and refetches
 * the rows, the cards and the sidebar badge. Snooze and dismiss invalidate `stats()` and `searches()` by
 * prefix.
 */
export const serviceReminderKeys = {
  all: ['service-reminders'] as const,
  search: (criteria: SearchServiceRemindersCriteria, page: number, limit: number): readonly unknown[] =>
    [...serviceReminderKeys.searches(), criteria, page, limit] as const,
  searches: (): readonly unknown[] => [...serviceReminderKeys.all, 'search'] as const,
  stats: (filters?: ServiceReminderQueueFilters): readonly unknown[] =>
    filters === undefined
      ? ([...serviceReminderKeys.all, 'stats'] as const)
      : ([...serviceReminderKeys.all, 'stats', filters] as const),
};
